var filterSortToggleBind = function() {
    if ($('.filter-label.open').length > 0 || $('.sort-label.open').length > 0) {
        $('.close-btn').one('click', function(e) {
            e.stopPropagation();
            $('.shade').remove()
          //  $('.filter-content').hide();
            $('.filter-label').removeClass('open');
            $('.sort-content').hide();
            $('.sort-label').removeClass('open');
            return false;
        });
        $('body').on('click', function(e) {
            e.stopPropagation();
            var filterContent = $('.filter-content'),
                sortContent = $('.sort-content'),
                filterLabel = $('.filter-label'),
                sortLabel = $('.sort-label'),
                facetWrapper = $('#wrapper-facet');

            if (!filterContent.is(e.target) && filterContent.has(e.target).length === 0 &&
                !facetWrapper.is(e.target) && facetWrapper.has(e.target).length === 0) {
                $('.shade').remove()
                $('body').removeClass('filter-open');
                //filterContent.hide();
                filterLabel.removeClass('open');

            }
            if (!sortContent.is(e.target) && sortContent.has(e.target).length === 0 &&
                !facetWrapper.is(e.target) && facetWrapper.has(e.target).length === 0) {
                $('.shade').remove()
                $('body').removeClass('filter-open');
                sortContent.hide();
                sortLabel.removeClass('open');

            }

        });
    }
};


//needs refactored when redesigned
var filterSortToggleBindMobile = () =>{
  if($('.filter-label.open').length > 0 || $('.sort-label.open').length > 0) {
    $('.close-btn').one('click', function(e) {
      e.stopPropagation();
      $('.shade').remove()
      $('.filter-content').hide();
      $('.filter-label').removeClass('open');
      $('.sort-content').hide();
      $('.sort-label').removeClass('open');
      return false;
    });
    $('body').on('click', function(e) {
      e.stopPropagation();
      var filterContent = $('.filter-content'),
        sortContent = $('.sort-content'),
        filterLabel = $('.filter-label'),
        sortLabel = $('.sort-label'),
        facetWrapper = $('#wrapper-facet');

      if(!filterContent.is(e.target) && filterContent.has(e.target).length === 0 &&
        !facetWrapper.is(e.target) && facetWrapper.has(e.target).length === 0) {
        $('.shade').remove()
        $('body').removeClass('filter-open');
        filterContent.hide();
        filterLabel.removeClass('open');

      }
      if(!sortContent.is(e.target) && sortContent.has(e.target).length === 0 &&
        !facetWrapper.is(e.target) && facetWrapper.has(e.target).length === 0) {
        $('.shade').remove()
        $('body').removeClass('filter-open');
        sortContent.hide();
        sortLabel.removeClass('open');

      }

    });
  }
}



//Desktop Facet Trigger
var desktopToggleFacets = () => {
    var $topFacets = $('.facet-item.top-facet'),
        $sideFacets = $('.facet-item.side-facet'),
        $body = $('body');
    $topFacets.on('click', function(e) {
        e.stopPropagation();
        if (!$(this).find('.facet-wrapper').is(":visible")) {
            $topFacets.find('.facet-wrapper').hide().parent().removeClass('open');
        }
        $(this).find('.facet-wrapper').show().parent().addClass('open');
    });
    $('[data-close-filter]').on('click', function(e) {
        e.stopPropagation();
        $(this).parents('.facet-wrapper').hide().parent().removeClass('open');
    });
    $('body:not(.facet-wrapper)').on('click', function(e) {
        $topFacets.find('.facet-wrapper').hide().parent().removeClass('open');
    });
};


//Tablet Facet Trigger
var tabletToggleFacets = () => {
    //Open-Close Filters
    var $filterTrigger = $('.filter-label');
    $filterTrigger.on('click', function(e) {
        e.stopPropagation();
        $('#wrapper-facet').detach().appendTo('#page');
        $('.shade').remove();

        $('#wrapper-facet br').remove();
        $('<div class="shade"></div>').insertAfter('#wrapper-facet');

        if ($('.filter-content').is(':visible')) {
            $('.sort-content').hide();
            $('.sort-label').removeClass('open');
            $('body').removeClass('filter-open filter');
            $('.shade').fadeOut();
            $('.filter-label').removeClass('open');
            $('.filter-label').removeClass('open');
            filterSortToggleBind();
        } else {
            $('body').addClass('filter-open filter');
            $('.sort-content').hide();
            $('.sort-label').removeClass('open');
            filterSortToggleBind();
        }
        $('.category-nav-facet').find('.facet').slideDown();

        if ($('.facet-title').length > 0) {
            $('.facet-title').each(function() {
                $(this).children('i').remove();
                if ($(this).parent('.facet-item').height() > 57) {
                  $(this).append('<i class="zmdi zmdi-chevron-down"></i>');
                } else {
                  $(this).append('<i class="zmdi zmdi-chevron-right"></i>');
                }

                if($(this).siblings('ul').children('li').length === 1 && $(this).text() == ""){
                	var link = $(this).siblings('ul').children('li').children('a');
                	$(link).appendTo($(this));
                	$(link).css('display', 'block');
                	$(link).css('padding', '22px 0 22px 10px');
                	$(this).css('padding', '0px');
                  $(this).children('i').remove();
                }

            });
        };
    });


    var $facetTitle = $('.facet-title');
    $facetTitle.on('click', function(e) {
        e.stopPropagation();
        if ($(this).siblings('.facet').length > 0) {
          if ($(this).siblings('.facet').is(":hidden")) {
              $(this).siblings('.facet').slideDown();
              $(this).children('i').removeClass('zmdi-chevron-right');
              $(this).children('i').addClass('zmdi-chevron-down');
          } else {
              $(this).siblings('.facet').slideUp();
              $(this).children('i').removeClass('zmdi-chevron-down');
              $(this).children('i').addClass('zmdi-chevron-right');
          }
        }

        if ($(this).next().children('.facet').length > 0) {
          if ($(this).next().children('.facet').is(":hidden")) {
              $(this).next().children('.facet').slideDown();
              $(this).children('i').removeClass('zmdi-chevron-right');
              $(this).children('i').addClass('zmdi-chevron-down');
          } else {
              $(this).next().children('.facet').slideUp();
              $(this).children('i').removeClass('zmdi-chevron-down');
              $(this).children('i').addClass('zmdi-chevron-right');
          }
        }
    });

    var $btnClose = $('.close-btn');
    $btnClose.on('click', function() {
        $('body').removeClass('filter-open');
    });
    //Open-Close Sort
    var $sortTrigger = $('.sort-label');
    $sortTrigger.on('click', function(e) {
        e.stopPropagation();

        $('.shade').remove()

        if (!$('.sort-content').is(':visible')) {
        //    $('.filter-content').hide();
            $('.filter-label').removeClass('open');
            $('.sort-content').slideToggle()
            $('.sort-label').toggleClass('open');
            filterSortToggleBind();
        } else {
            $('.shade').remove()
            $('body').removeClass('filter-open');
          //  $('.filter-content').hide();
            $('.filter-label').removeClass('open');
            $('.sort-content').slideUp();
            $('.sort-label').removeClass('open');
            filterSortToggleBind();
        }
        $('.category-nav-facet').find('.facet').slideDown()
    });
};


//Mobile Facet Trigger
var mobileToggleFacets = () => {
    //Open-Close Filters
    var $filterTrigger = $('.filter-label');
    $filterTrigger.on('click', function(e) {
        e.stopPropagation();
        $('body').addClass('filter-open');
        if (!$('.filter-content').is(':visible')) {
            $('.sort-content').hide();
            $('.sort-label').removeClass('open');
            $('.filter-content').slideToggle()
            $('.filter-label').toggleClass('open');
            filterSortToggleBindMobile();
        } else {
            $('body').removeClass('filter-open');
            $('.sort-content').hide();
            $('.sort-label').removeClass('open');
            $('.filter-content').slideUp();
            $('.filter-label').removeClass('open');
            filterSortToggleBindMobile();
        }
        $('#ghostDiv').css('height', $('#mobileFilterSelected').height() + 30);
        $('.category-nav-facet').find('.facet').slideDown();

        if ($('.facet-title').length > 0) {
            $('.facet-title').each(function() {
                $(this).children('i').remove();
                if ($(this).parent('.facet-item').height() > 57) {
                  $(this).append('<i class="zmdi zmdi-chevron-down"></i>');
                } else {
                  $(this).append('<i class="zmdi zmdi-chevron-right"></i>');
                }
            });
        };
    });
    var $sortTrigger = $('.sort-label');
    $sortTrigger.on('click', function(e) {
        e.stopPropagation();
        $('body').addClass('filter-open');
        if (!$('.sort-content').is(':visible')) {
            $('.filter-content').hide();
            $('.filter-label').removeClass('open');
            $('.sort-content').slideDown()
            $('.sort-label').toggleClass('open');
            filterSortToggleBindMobile();
        } else {
            $('body').removeClass('filter-open');
            $('.filter-content').hide();
            $('.filter-label').removeClass('open');
            $('.sort-content').slideUp();
            $('.sort-label').removeClass('open');
            filterSortToggleBindMobile();
        }
        $('.category-nav-facet').find('.facet').slideDown()
    });
    var $facetTitle = $('.facet-title');
    $facetTitle.on('click', function(e) {
        e.stopPropagation();
        if ($(this).next('.facet').length > 0) {
          if ($(this).next('.facet').is(":hidden")) {
              $(this).next('.facet').slideDown();
              $(this).children('i').removeClass('zmdi-chevron-right');
              $(this).children('i').addClass('zmdi-chevron-down');
          } else {
              $(this).next('.facet').slideUp();
              $(this).children('i').removeClass('zmdi-chevron-down');
              $(this).children('i').addClass('zmdi-chevron-right');
          }
        }

        if ($(this).next().children('.facet').length > 0) {
          if ($(this).next().children('.facet').is(":hidden")) {
              $(this).next().children('.facet').slideDown();
              $(this).children('i').removeClass('zmdi-chevron-right');
              $(this).children('i').addClass('zmdi-chevron-down');
          } else {
              $(this).next().children('.facet').slideUp();
              $(this).children('i').removeClass('zmdi-chevron-down');
              $(this).children('i').addClass('zmdi-chevron-right');
          }
        }
    });
    var $btnClose = $('.close-btn');
    $btnClose.on('click', function() {
        $('body').removeClass('filter-open');
    });
};

export {
    desktopToggleFacets,
    tabletToggleFacets,
    mobileToggleFacets
}
